/*
 * BROWSER SESSION API CLIENT
 * ==========================
 * This is a small wrapper around `CoreApiClient`.
 *
 * Its job is simple:
 * - Always send the browser session cookie with each request.
 * - Keep the rest of the request/response handling in one shared place.
 *
 * Why that matters:
 * - The current app uses Azure Static Web Apps cookie-based auth.
 * - The browser does not need to attach bearer tokens for normal page calls.
 */
import { CoreApiClient, ApiRequestOptions } from "./coreApiClient";

// Small wrapper around the shared API client that always sends the SWA session cookie.
export class BrowserSessionApiClient {
  private readonly client: CoreApiClient;

  constructor(baseUrl: string) {
    this.client = new CoreApiClient(baseUrl, (input, init) =>
      fetch(input, {
        ...init,
        credentials: "include",
      })
    );
  }

  async request<T>(path: string, options: ApiRequestOptions = {}): Promise<T> {
    return this.client.request<T>(path, {
      ...options,
      credentials: "include",
    });
  }
}
